'use client'

import { useTranslations } from 'next-intl'
import { useTransition } from 'react'

import { useSignOut } from '@maestro/commerce-blocks/components/sign-out-button/batons/use-sign-out'
import { Link } from '@pearlconvert/ui/components/link'

export default function SignOutBtn() {
  const [isPending, startTransition] = useTransition()
  const t = useTranslations('commerce-blocks')
  const { handleSignOut } = useSignOut()

  return (
    <Link
      href="#"
      aria-disabled={isPending}
      onClick={() => {
        if (!isPending) {
          startTransition(handleSignOut)
        }
      }}
      className="my-account__sign-out"
    >
      {t('auth.logout.title')}
    </Link>
  )
}
